// CorrectWrongクラス
export class CorrectWrong {
    result: boolean | null;
    progress: number;

    constructor(result: boolean | null = null, progress: number = 0) {
        this.result = result;
        this.progress = progress;
    }

    static fromData(data: any): CorrectWrong {
        return new CorrectWrong(data.result, data.progress);
    }
}

// SubQuizHistoriesクラス
export class SubQuizHistories {
    answer: string;
    is_correct_answer: boolean;

    constructor(answer: string, is_correct_answer: boolean) {
        this.answer = answer;
        this.is_correct_answer = is_correct_answer;
    }

    static fromData(data: any): SubQuizHistories {
        return new SubQuizHistories(data.answer, data.is_correct_answer);
    }
}

// QuizHistoriesクラス
export class QuizHistories {
    quiz_id: number;
    answer: string;
    is_correct_answer: boolean;
    sub_quizzes?: SubQuizHistories[];

    constructor(quiz_id: number, is_correct_answer: boolean, answer: string, sub_quizzes?: SubQuizHistories[]) {
        this.quiz_id = quiz_id;
        this.is_correct_answer = is_correct_answer;
        this.answer = answer;
        if (sub_quizzes !== undefined) {
            this.sub_quizzes = sub_quizzes;
        }
    }

    static fromData(data: any): QuizHistories {
        const sub_quizzes = data.sub_quizzes
            ? data.sub_quizzes.map((sub_quiz: any) => SubQuizHistories.fromData(sub_quiz))
            : undefined;
        return new QuizHistories(data.quiz_id, data.is_correct_answer, data.answer, sub_quizzes);
    }
}

// QuestionHistoriesクラス
export class QuestionHistories {
    question_id: number;
    is_correct_answer: boolean;
    quiz_histories: QuizHistories[];
    study_start_datetime: string;
    study_end_datetime: string;

    constructor(question_id: number, is_correct_answer: boolean, quiz_histories: QuizHistories[], study_start_datetime: string, study_end_datetime: string) {
        this.question_id = question_id;
        this.is_correct_answer = is_correct_answer;
        this.quiz_histories = quiz_histories;
        this.study_start_datetime = study_start_datetime;
        this.study_end_datetime = study_end_datetime;
    }

    static fromData(data: any): QuestionHistories {
        const quiz_histories = data.quiz_histories.map((histories: any) => QuizHistories.fromData(histories));
        return new QuestionHistories(data.question_id, data.is_correct_answer, quiz_histories, data.study_start_datetime, data.study_end_datetime);
    }
}